(() => {
  const SECTION_SELECTOR = '[data-digi-pack-progressivo]';

  const CART_ADD_URL = `${window.Shopify?.routes?.root || '/'}cart/add.js`;
  const CART_URL = `${window.Shopify?.routes?.root || '/'}cart`;

  const requestCartAddWithXhr = (
    url,
    items,
    timeout = 20000
  ) => {
    return new Promise((resolve, reject) => {
      const request = new XMLHttpRequest();

      request.open('POST', url, true);
      request.timeout = timeout;
      request.setRequestHeader(
        'Content-Type',
        'application/json'
      );
      request.setRequestHeader(
        'Accept',
        'application/json'
      );

      request.onload = () => {
        const data = parseJson(
          request.responseText || '{}',
          {}
        );

        if (request.status >= 200 && request.status < 300) {
          resolve(data);
          return;
        }

        reject(
          new Error(
            data.description ||
              data.message ||
              'Não foi possível adicionar o combo.'
          )
        );
      };

      request.onerror = () => {
        reject(
          new Error(
            'Falha de conexão ao adicionar o combo.'
          )
        );
      };

      request.ontimeout = () => {
        const error = new Error(
          'A adição demorou mais que o esperado. Verifique o carrinho e tente novamente.'
        );

        error.name = 'TimeoutError';
        reject(error);
      };

      request.send(JSON.stringify({ items }));
    });
  };

  const formatMoney = (cents, moneyFormat = 'R$ {{amount_with_comma_separator}}') => {
    const value = Number(cents) || 0;
    const amount = (value / 100)
      .toFixed(2)
      .replace('.', ',');

    return moneyFormat
      .replace('{{amount}}', amount)
      .replace('{{amount_no_decimals}}', String(Math.round(value / 100)))
      .replace('{{amount_with_comma_separator}}', amount)
      .replace(
        '{{amount_no_decimals_with_comma_separator}}',
        String(Math.round(value / 100))
      );
  };

  const parseNumber = (value, fallback = 0) => {
    const parsedValue = Number(value);

    return Number.isFinite(parsedValue)
      ? parsedValue
      : fallback;
  };

  const escapeHtml = (value = '') => {
    const element = document.createElement('div');

    element.textContent = value;

    return element.innerHTML;
  };

  const parseJson = (value, fallback = null) => {
    try {
      return JSON.parse(value);
    } catch (error) {
      return fallback;
    }
  };

  const getConfiguration = (section) => {
    const configurationElement = section.querySelector(
      '[data-digi-pack-progressivo-configuration]'
    );

    if (!configurationElement) {
      return {};
    }

    return parseJson(
      configurationElement.textContent.trim(),
      {}
    );
  };

  const getTemplate = (section, selector) => {
    return section.querySelector(selector);
  };

  const createElementFromTemplate = (template) => {
    if (!template) {
      return null;
    }

    return template.content.firstElementChild.cloneNode(true);
  };

  const normalizeProduct = (card) => {
    if (!card) {
      return null;
    }

    return {
      card,
      variantId: String(card.dataset.variantId || ''),
      productId: String(card.dataset.productId || ''),
      title: card.dataset.productTitle || '',
      variantTitle: card.dataset.variantTitle || '',
      family: card.dataset.productFamily || '',
      image: card.dataset.productImage || '',
      price: parseNumber(card.dataset.price),
      comparePrice: parseNumber(card.dataset.compareAtPrice),
      available: card.dataset.available !== 'false',
      quantity: 0
    };
  };

  const initSection = (section) => {
    if (!section || section.dataset.packProgressivoReady === 'true') {
      return;
    }

    section.dataset.packProgressivoReady = 'true';

    const configuration = getConfiguration(section);

    const moneyFormat =
      configuration.moneyFormat ||
      section.dataset.moneyFormat ||
      'R$ {{amount_with_comma_separator}}';

    const minimumItems = Math.max(
      1,
      parseNumber(
        configuration.minimumItems ??
          section.dataset.minimumItems,
        1
      )
    );

    const cartBehavior =
    configuration.cartBehavior ||
    section.dataset.cartBehavior ||
    'drawer';

    const giftMode =
      configuration.giftMode ||
      section.dataset.giftMode ||
      'cumulative';

    const masterVariantId = String(
      configuration.masterVariantId ||
        section.dataset.masterVariantId ||
        ''
    );

    const bundleKey =
      configuration.bundleKey ||
      section.dataset.bundleKey ||
      'bold-master-pack';

    const tabs = Array.from(
      section.querySelectorAll('[data-digi-pack-progressivo-tab]')
    );

    const panels = Array.from(
      section.querySelectorAll('[data-digi-pack-progressivo-panel]')
    );

    const cards = Array.from(
      section.querySelectorAll('[data-digi-pack-progressivo-product]')
    );

    const steps = Array.from(
      section.querySelectorAll('[data-digi-pack-progressivo-step]')
    )
      .map((element, index) => ({
        element,
        index,
        id: element.dataset.stepId || `step-${index + 1}`,
        requiredItems: Math.max(
          1,
          parseNumber(element.dataset.requiredItems)
        ),
        discountPercentage: Math.max(
        0,
        parseNumber(element.dataset.discount)
        ),
        shortTitle: element.dataset.shortTitle || '',
        lockedTitle: element.dataset.lockedTitle || '',
        lockedText: element.dataset.lockedText || '',
        unlockedTitle: element.dataset.unlockedTitle || '',
        unlockedText: element.dataset.unlockedText || '',
        giftVariantId: String(
          element.dataset.giftVariantId || ''
        ),
giftTitle: element.dataset.giftTitle || '',
giftImage: element.dataset.giftImage || '',
giftComparePrice: Math.max(
  0,
  parseNumber(element.dataset.giftComparePrice)
),
giftPrice: Math.max(
  0,
  parseNumber(element.dataset.giftPrice)
)
      }))
      .sort((stepA, stepB) => {
        return stepA.requiredItems - stepB.requiredItems;
      });

    const progressFill = section.querySelector(
      '[data-digi-pack-progressivo-progress-fill]'
    );

    const progressTitle = section.querySelector(
      '[data-digi-pack-progressivo-progress-title]'
    );

    const progressText = section.querySelector(
      '[data-digi-pack-progressivo-progress-text]'
    );

    const collectionTitle = section.querySelector(
      '[data-digi-pack-progressivo-collection-title]'
    );

    const collectionDescription = section.querySelector(
      '[data-digi-pack-progressivo-collection-description]'
    );

    const summary = section.querySelector(
      '[data-digi-pack-progressivo-summary]'
    );

    const summaryToggle = section.querySelector(
      '[data-digi-pack-progressivo-summary-toggle]'
    );

    const summaryOverlay = section.querySelector(
    '[data-digi-pack-progressivo-summary-overlay]'
    );

    const summaryItems = section.querySelector(
      '[data-digi-pack-progressivo-summary-items]'
    );

    const summaryEmpty = section.querySelector(
      '[data-digi-pack-progressivo-summary-empty]'
    );

    const summaryGifts = section.querySelector(
      '[data-digi-pack-progressivo-summary-gifts]'
    );

    const summaryGiftsList = section.querySelector(
      '[data-digi-pack-progressivo-summary-gifts-list]'
    );

    const summaryBenefit = section.querySelector(
      '[data-digi-pack-progressivo-summary-benefit]'
    );

    const summaryBenefitTitle = section.querySelector(
      '[data-digi-pack-progressivo-summary-benefit-title]'
    );

    const summaryBenefitText = section.querySelector(
      '[data-digi-pack-progressivo-summary-benefit-text]'
    );

    const summaryCountElements = Array.from(
      section.querySelectorAll(
        '[data-digi-pack-progressivo-summary-count]'
      )
    );

    const mobileCountElement = section.querySelector(
    '[data-digi-pack-progressivo-mobile-count]'
    );

    const mobileTotalElement = section.querySelector(
    '[data-digi-pack-progressivo-mobile-total]'
    );

    const mobileProgressFill = section.querySelector(
    '[data-digi-pack-progressivo-mobile-progress-fill]'
    );

    const mobileProgressText = section.querySelector(
    '[data-digi-pack-progressivo-mobile-progress-text]'
    );

    const subtotalElement = section.querySelector(
      '[data-digi-pack-progressivo-subtotal]'
    );

    const discountElement = section.querySelector(
      '[data-digi-pack-progressivo-discount]'
    );

    const discountRow = section.querySelector(
    '[data-digi-pack-progressivo-discount-row]'
    );

    const discountLabel = section.querySelector(
    '[data-digi-pack-progressivo-discount-label]'
    );

    const totalElement = section.querySelector(
      '[data-digi-pack-progressivo-total]'
    );

    const summaryStatus = section.querySelector(
    '[data-digi-pack-progressivo-status]'
    );

    const submitButton = section.querySelector(
      '[data-digi-pack-progressivo-submit]'
    );

    const clearButton = section.querySelector(
      '[data-digi-pack-progressivo-clear]'
    );

    const errorElement = section.querySelector(
      '[data-digi-pack-progressivo-error]'
    );

    const summaryItemTemplate = getTemplate(
      section,
      '[data-digi-pack-progressivo-summary-item-template]'
    );

    const giftTemplate = getTemplate(
      section,
      '[data-digi-pack-progressivo-gift-template]'
    );

    const products = new Map();

    cards.forEach((card) => {
      const product = normalizeProduct(card);

      if (!product?.variantId) {
        return;
      }

      products.set(product.variantId, product);
    });

    const state = {
      activePanelId: '',
      loading: false
    };

    const getSelectedProducts = () => {
      return Array.from(products.values()).filter(
        (product) => product.quantity > 0
      );
    };

    const getTotalQuantity = () => {
      return getSelectedProducts().reduce(
        (total, product) => total + product.quantity,
        0
      );
    };

    const getSubtotal = () => {
      return getSelectedProducts().reduce(
        (total, product) => {
          return total + product.price * product.quantity;
        },
        0
      );
    };

    const getUnlockedSteps = (totalQuantity) => {
      return steps.filter(
        (step) => totalQuantity >= step.requiredItems
      );
    };

    const getActiveStep = (totalQuantity) => {
      const unlockedSteps = getUnlockedSteps(totalQuantity);

      return unlockedSteps.at(-1) || null;
    };

    const getNextStep = (totalQuantity) => {
      return (
        steps.find(
          (step) => totalQuantity < step.requiredItems
        ) || null
      );
    };

    const getDiscountPercentage = (totalQuantity) => {
      return (
        getActiveStep(totalQuantity)?.discountPercentage || 0
      );
    };

    const getUnlockedGifts = (totalQuantity) => {
      const unlockedGiftSteps = getUnlockedSteps(
        totalQuantity
      ).filter((step) => step.giftVariantId);

      if (giftMode === 'current') {
        const lastGiftStep = unlockedGiftSteps.at(-1);

        return lastGiftStep ? [lastGiftStep] : [];
      }

      return unlockedGiftSteps;
    };

    const getValues = () => {
      const totalQuantity = getTotalQuantity();
      const subtotal = getSubtotal();
      const discountPercentage =
        getDiscountPercentage(totalQuantity);

      const discount = Math.round(
        subtotal * (discountPercentage / 100)
      );

      return {
        totalQuantity,
        subtotal,
        discountPercentage,
        discount,
        total: Math.max(0, subtotal - discount)
      };
    };

    const setError = (message = '') => {
      if (!errorElement) {
        return;
      }

      errorElement.textContent = message;
      errorElement.hidden = !message;
    };

const setLoading = (loading) => {
  state.loading = loading;

  if (!submitButton) {
    return;
  }

  const submitLabel = submitButton.querySelector(
    '[data-digi-pack-progressivo-submit-label]'
  );

  const submitLoading = submitButton.querySelector(
    '[data-digi-pack-progressivo-submit-loading]'
  );

  submitButton.classList.toggle(
    'is-loading',
    loading
  );

  submitButton.setAttribute(
    'aria-busy',
    String(loading)
  );

  submitButton.disabled = loading;

  if (submitLabel) {
    submitLabel.hidden = loading;
  }

  if (submitLoading) {
    submitLoading.hidden = !loading;
  }
};

    const updateCollectionHeading = (activeTab) => {
      if (!activeTab) {
        return;
      }

      if (collectionTitle) {
        collectionTitle.textContent =
          activeTab.dataset.collectionTitle || '';
      }

      if (collectionDescription) {
        const description =
          activeTab.dataset.collectionDescription || '';

        collectionDescription.innerHTML = description;
        collectionDescription.hidden = !description;
      }
    };

    const activateTab = (panelId, focusTab = false) => {
      if (!panelId) {
        return;
      }

      state.activePanelId = panelId;

      let activeTab = null;

      tabs.forEach((tab) => {

const isActive =
  tab.getAttribute('aria-controls') === panelId;

        tab.classList.toggle('is-active', isActive);
        tab.setAttribute(
          'aria-selected',
          String(isActive)
        );

        tab.tabIndex = isActive ? 0 : -1;

        if (isActive) {
          activeTab = tab;
        }
      });

      panels.forEach((panel) => {
        const isActive =
        panel.id === panelId;

        panel.hidden = !isActive;
        panel.classList.toggle('is-active', isActive);
      });

      updateCollectionHeading(activeTab);

      if (focusTab && activeTab) {
        activeTab.focus();
      }
    };

    const updateProductCards = () => {
      products.forEach((product) => {
        const quantityElement = product.card.querySelector(
        '[data-digi-pack-progressivo-quantity-value]'
        );

        const minusButton = product.card.querySelector(
        '[data-digi-pack-progressivo-decrease]'
        );

        const plusButton = product.card.querySelector(
        '[data-digi-pack-progressivo-increase]'
        );

        product.card.classList.toggle(
          'is-selected',
          product.quantity > 0
        );

        product.card.classList.toggle(
          'is-unavailable',
          !product.available
        );

        if (quantityElement) {
          quantityElement.textContent =
            String(product.quantity);
        }

        if (minusButton) {
          minusButton.disabled =
            product.quantity <= 0 ||
            !product.available;
        }

        if (plusButton) {
          plusButton.disabled = !product.available;
        }
      });
    };

const updateMobileProgress = (totalQuantity) => {
  if (!mobileProgressFill || !mobileProgressText) {
    return;
  }

  const activeStep = getActiveStep(totalQuantity);
  const nextStep = getNextStep(totalQuantity);

  let progressPercentage = 0;
  let message = '';

  /*
    Antes do mínimo, apresenta o desconto
    da primeira faixa que será liberada.
  */
  if (totalQuantity < minimumItems) {
    const remainingItems =
      minimumItems - totalQuantity;

const maximumRequiredItems =
  steps[steps.length - 1]?.requiredItems ||
  minimumItems;

progressPercentage =
  maximumRequiredItems > 0
    ? (totalQuantity / maximumRequiredItems) * 100
    : 0;

    const firstBenefitStep =
      steps.find(
        (step) =>
          step.requiredItems >= minimumItems
      ) ||
      nextStep ||
      steps[0];

    const firstBenefit =
      firstBenefitStep?.shortTitle ||
      (
        firstBenefitStep?.discountPercentage > 0
          ? `${firstBenefitStep.discountPercentage}% OFF`
          : 'desconto'
      );

    message =
      `Adicione mais ${remainingItems} ${
        remainingItems === 1 ? 'item' : 'itens'
      } para liberar seu combo com ${firstBenefit}`;

  /*
    Depois do mínimo, aponta para
    a próxima vantagem.
  */
  } else if (nextStep) {
const maximumRequiredItems =
  steps[steps.length - 1]?.requiredItems ||
  minimumItems;

progressPercentage =
  maximumRequiredItems > 0
    ? (totalQuantity / maximumRequiredItems) * 100
    : 0;

    const remainingItems =
      nextStep.requiredItems - totalQuantity;

    const nextBenefit =
      nextStep.shortTitle ||
      (
        nextStep.discountPercentage > 0
          ? `${nextStep.discountPercentage}% OFF`
          : 'a próxima vantagem'
      );

    const currentBenefit =
      activeStep?.shortTitle ||
      (
        activeStep?.discountPercentage > 0
          ? `${activeStep.discountPercentage}% OFF`
          : ''
      );

    if (currentBenefit) {
      message =
        `${currentBenefit} liberado! Adicione mais ` +
        `${remainingItems} ${
          remainingItems === 1 ? 'item' : 'itens'
        } para ganhar ${nextBenefit}`;
    } else {
      message =
        `Combo liberado! Adicione mais ${remainingItems} ${
          remainingItems === 1 ? 'item' : 'itens'
        } para ganhar ${nextBenefit}`;
    }

  /*
    Última etapa atingida.
  */
  } else if (activeStep) {
    progressPercentage = 100;

    const maximumBenefit =
      activeStep.shortTitle ||
      (
        activeStep.discountPercentage > 0
          ? `${activeStep.discountPercentage}% OFF`
          : 'Vantagem máxima'
      );

    message =
      `${maximumBenefit} liberado! ` +
      'Você chegou à vantagem máxima';
  } else {
    progressPercentage = 100;
    message = 'Seu combo está liberado';
  }

  mobileProgressFill.style.width =
    `${Math.min(
      100,
      Math.max(0, progressPercentage)
    )}%`;

  mobileProgressText.textContent = message;
};

    const updateProgress = (totalQuantity) => {
      const activeStep = getActiveStep(totalQuantity);
      const nextStep = getNextStep(totalQuantity);
let progressPercentage = 0;

if (steps.length > 0) {
  const firstStep = steps[0];
  const lastStep = steps.at(-1);

if (totalQuantity >= lastStep.requiredItems) {
  progressPercentage = 100;
} else {
    const nextStepIndex = steps.findIndex(
      (step) => totalQuantity < step.requiredItems
    );

    const previousStep =
      nextStepIndex > 0
        ? steps[nextStepIndex - 1]
        : null;

const getStepPosition = (index) => {
  return ((index + 0.5) / steps.length) * 100;
};

const nextProgressPosition =
  getStepPosition(nextStepIndex);

const previousProgressPosition =
  previousStep
    ? getStepPosition(nextStepIndex - 1)
    : 0;

    const previousRequiredItems =
      previousStep?.requiredItems || 0;

    const quantityInterval =
      steps[nextStepIndex].requiredItems -
      previousRequiredItems;

    const quantityProgress =
      quantityInterval > 0
        ? (
            totalQuantity -
            previousRequiredItems
          ) / quantityInterval
        : 0;

    progressPercentage =
      previousProgressPosition +
      (
        nextProgressPosition -
        previousProgressPosition
      ) * quantityProgress;
  }
}

if (progressFill) {
  progressFill.style.width =
    `${Math.min(
      100,
      Math.max(0, progressPercentage)
    )}%`;
}

      steps.forEach((step) => {
        const isUnlocked =
          totalQuantity >= step.requiredItems;

        const isActive =
          activeStep?.id === step.id;

        const isCurrent =
          nextStep?.id === step.id;

        step.element.classList.toggle(
          'is-unlocked',
          isUnlocked
        );

        step.element.classList.toggle(
          'is-active',
          isActive
        );

        step.element.classList.toggle(
          'is-current',
          isCurrent
        );
      });

      if (!steps.length) {
        if (progressTitle) {
          progressTitle.textContent =
            totalQuantity > 0
              ? 'Seu combo está sendo montado'
              : 'Comece a montar seu combo';
        }

        if (progressText) {
          progressText.textContent =
            totalQuantity > 0
              ? `${totalQuantity} ${
                  totalQuantity === 1
                    ? 'produto selecionado'
                    : 'produtos selecionados'
                }.`
              : 'Escolha seus produtos favoritos.';
        }

        return;
      }

      if (nextStep) {
        const remainingItems = Math.max(
          0,
          nextStep.requiredItems - totalQuantity
        );

        if (progressTitle) {
          progressTitle.textContent =
            nextStep.lockedTitle ||
            'Sua próxima vantagem';
        }

        if (progressText) {
          progressText.textContent =
            nextStep.lockedText ||
            `Adicione mais ${remainingItems} ${
              remainingItems === 1 ? 'produto' : 'produtos'
            } para desbloquear ${nextStep.shortTitle}.`;
        }

        return;
      }

      if (activeStep) {
        if (progressTitle) {
          progressTitle.textContent =
            activeStep.unlockedTitle ||
            'Vantagem desbloqueada!';
        }

        if (progressText) {
          progressText.textContent =
            activeStep.unlockedText ||
            'Você liberou a maior vantagem do combo.';
        }
      }
    };

    const createFallbackSummaryItem = (product) => {
      const item = document.createElement('article');

      item.className =
        'digi-pack-progressivo__summary-item';

      item.dataset.summaryVariantId =
        product.variantId;

      item.innerHTML = `
        <div class="digi-pack-progressivo__summary-item-media">
          ${
            product.image
              ? `
                <img
                  class="digi-pack-progressivo__summary-item-image"
                  src="${escapeHtml(product.image)}"
                  alt=""
                  loading="lazy"
                >
              `
              : ''
          }
        </div>

        <div class="digi-pack-progressivo__summary-item-content">
          <p class="digi-pack-progressivo__summary-item-title">
            ${escapeHtml(product.title)}
          </p>

          <p
            class="digi-pack-progressivo__summary-item-price"
            data-summary-item-price
          ></p>
        </div>

        <div class="digi-pack-progressivo__summary-item-quantity">
          <button
            type="button"
            data-summary-item-decrease
            aria-label="Diminuir quantidade de ${escapeHtml(product.title)}"
          >
            −
          </button>

          <span data-summary-quantity></span>

          <button
            type="button"
            data-summary-item-increase
            aria-label="Aumentar quantidade de ${escapeHtml(product.title)}"
          >
            +
          </button>
        </div>
      `;

      return item;
    };

    const createSummaryItem = (product) => {
      const item =
        createElementFromTemplate(summaryItemTemplate) ||
        createFallbackSummaryItem(product);

      item.dataset.summaryVariantId =
        product.variantId;

      const image = item.querySelector(
        '[data-summary-item-image]'
      );

      const title = item.querySelector(
        '[data-summary-item-title]'
      );

      const price = item.querySelector(
        '[data-summary-item-price]'
      );

        const quantity = item.querySelector(
        '[data-summary-item-quantity]'
        );

      const minusButton = item.querySelector(
        '[data-summary-item-decrease]'
      );

      const plusButton = item.querySelector(
        '[data-summary-item-increase]'
      );

      if (image) {
        if (product.image) {
          image.src = product.image;
          image.alt = product.title;
          image.hidden = false;
        } else {
          image.hidden = true;
        }
      }

      if (title) {
        title.textContent = product.title;
      }

if (price) {
  const currentTotal =
    product.price * product.quantity;

  const compareTotal =
    product.comparePrice * product.quantity;

  if (
    product.comparePrice > 0 &&
    product.comparePrice > product.price
  ) {
    price.innerHTML = `
      <s class="digi-pack-progressivo__summary-item-compare-price">
        ${formatMoney(compareTotal, moneyFormat)}
      </s>

      <strong>
        ${formatMoney(currentTotal, moneyFormat)}
      </strong>
    `;
  } else {
    price.textContent = formatMoney(
      currentTotal,
      moneyFormat
    );
  }
}

      if (quantity) {
        quantity.textContent =
          String(product.quantity);
      }

      if (minusButton) {
        minusButton.setAttribute(
          'aria-label',
          `Diminuir quantidade de ${product.title}`
        );
      }

      if (plusButton) {
        plusButton.setAttribute(
          'aria-label',
          `Aumentar quantidade de ${product.title}`
        );
      }

      return item;
    };

    const updateSummaryItems = (selectedProducts) => {
      if (!summaryItems) {
        return;
      }

      summaryItems.replaceChildren();

      selectedProducts.forEach((product) => {
        summaryItems.appendChild(
          createSummaryItem(product)
        );
      });

      summaryItems.hidden =
        selectedProducts.length === 0;

      if (summaryEmpty) {
        summaryEmpty.hidden =
          selectedProducts.length > 0;
      }
    };

    const createFallbackGift = (step) => {
      const gift = document.createElement('article');

      gift.className =
        'digi-pack-progressivo__gift';

      gift.innerHTML = `
        <div class="digi-pack-progressivo__gift-media">
          ${
            step.giftImage
              ? `
                <img
                  class="digi-pack-progressivo__gift-image"
                  src="${escapeHtml(step.giftImage)}"
                  alt=""
                  loading="lazy"
                >
              `
              : ''
          }
        </div>

        <div class="digi-pack-progressivo__gift-content">
          <p
            class="digi-pack-progressivo__gift-title"
            data-gift-title
          ></p>

          <span class="digi-pack-progressivo__gift-label">
            BRINDE GRÁTIS
          </span>
        </div>
      `;

      return gift;
    };

    const createGift = (step) => {
      const gift =
        createElementFromTemplate(giftTemplate) ||
        createFallbackGift(step);

      gift.dataset.giftVariantId =
        step.giftVariantId;

      const image = gift.querySelector(
        '[data-gift-image]'
      );

      const title = gift.querySelector(
        '[data-gift-title]'
      );

const comparePrice = gift.querySelector(
  '[data-gift-compare-price]'
);

const giftPrice = gift.querySelector(
  '[data-gift-price]'
);

      if (image) {
        if (step.giftImage) {
          image.src = step.giftImage;
          image.alt = step.giftTitle;
          image.hidden = false;
        } else {
          image.hidden = true;
        }
      }

      if (title) {
        title.textContent =
          step.giftTitle || 'Brinde do combo';
      }

if (comparePrice) {
  comparePrice.textContent = formatMoney(
    step.giftComparePrice,
    moneyFormat
  );

  comparePrice.hidden =
    step.giftComparePrice <= 0;
}

if (giftPrice) {
  giftPrice.textContent = formatMoney(
    step.giftPrice,
    moneyFormat
  );
}

      return gift;
    };

    const updateGifts = (totalQuantity) => {
      if (!summaryGifts || !summaryGiftsList) {
        return;
      }

      const gifts = getUnlockedGifts(totalQuantity);

      summaryGiftsList.replaceChildren();

      gifts.forEach((step) => {
        summaryGiftsList.appendChild(
          createGift(step)
        );
      });

      summaryGifts.hidden = gifts.length === 0;
    };

    const updateBenefit = (totalQuantity) => {
      if (!summaryBenefit) {
        return;
      }

      const activeStep = getActiveStep(totalQuantity);
      const nextStep = getNextStep(totalQuantity);

      if (activeStep) {
        summaryBenefit.hidden = false;

        if (summaryBenefitTitle) {
          summaryBenefitTitle.textContent =
            activeStep.unlockedTitle ||
            `${activeStep.shortTitle} desbloqueado`;
        }

        if (summaryBenefitText) {
          summaryBenefitText.textContent =
            activeStep.unlockedText ||
            'Seu benefício será aplicado automaticamente.';
        }

        return;
      }

      if (nextStep && totalQuantity > 0) {
        const remainingItems =
          nextStep.requiredItems - totalQuantity;

        summaryBenefit.hidden = false;

        if (summaryBenefitTitle) {
          summaryBenefitTitle.textContent =
            nextStep.lockedTitle ||
            'Sua próxima vantagem';
        }

        if (summaryBenefitText) {
          summaryBenefitText.textContent =
            nextStep.lockedText ||
            `Adicione mais ${remainingItems} ${
              remainingItems === 1 ? 'produto' : 'produtos'
            } para liberar ${nextStep.shortTitle}.`;
        }

        return;
      }

      summaryBenefit.hidden = true;
    };

    const updateSubmitButton = (totalQuantity) => {
      if (!submitButton) {
        return;
      }

      const missingItems = Math.max(
        0,
        minimumItems - totalQuantity
      );

const isDisabled =
  state.loading ||
  totalQuantity < minimumItems;

      submitButton.disabled = isDisabled;

      if (clearButton) {
        clearButton.hidden = totalQuantity === 0;
        clearButton.disabled = state.loading;
      }

if (summaryStatus) {
  const shouldShowStatus = missingItems > 0;

  summaryStatus.hidden = !shouldShowStatus;

  if (shouldShowStatus) {
    summaryStatus.textContent =
      `Adicione mais ${missingItems} ${
        missingItems === 1 ? 'produto' : 'produtos'
      } para montar o combo.`;
  } else {
    summaryStatus.textContent = '';
  }
}
    };

    const updateSummary = () => {
      const selectedProducts = getSelectedProducts();
      const values = getValues();

      summaryCountElements.forEach((element) => {
        element.textContent =
          `${values.totalQuantity} ${
            values.totalQuantity === 1
              ? 'item'
              : 'itens'
          }`;
      });

if (mobileCountElement) {
  mobileCountElement.textContent =
    `${values.totalQuantity} ${
      values.totalQuantity === 1
        ? 'item'
        : 'itens'
    }`;
}

if (mobileTotalElement) {
  mobileTotalElement.textContent = formatMoney(
    values.total,
    moneyFormat
  );
}

      if (subtotalElement) {
        subtotalElement.textContent = formatMoney(
          values.subtotal,
          moneyFormat
        );
      }

if (discountRow) {
  discountRow.hidden = false;
}

if (discountLabel) {
  discountLabel.textContent =
    `Desconto ${values.discountPercentage}%`;
}

if (discountElement) {
  discountElement.textContent =
    `− ${formatMoney(
      values.discount,
      moneyFormat
    )}`;
}

      if (totalElement) {
        totalElement.textContent = formatMoney(
          values.total,
          moneyFormat
        );
      }

      updateSummaryItems(selectedProducts);
      updateGifts(values.totalQuantity);
      updateBenefit(values.totalQuantity);
      updateSubmitButton(values.totalQuantity);
    };

const render = () => {
  const totalQuantity = getTotalQuantity();

  updateProductCards();
  updateProgress(totalQuantity);
  updateMobileProgress(totalQuantity);
  updateSummary();
};

    const changeQuantity = (
      variantId,
      amount,
      options = {}
    ) => {
      const product = products.get(String(variantId));

      if (!product || !product.available) {
        return;
      }

      const previousQuantity = product.quantity;

      product.quantity = Math.max(
        0,
        product.quantity + amount
      );

      if (
        options.openSummary &&
        previousQuantity === 0 &&
        product.quantity > 0 &&
        window.matchMedia('(max-width: 989px)').matches
      ) {
        openSummary();
      }

      setError('');
      render();
    };

    const clearSelection = () => {
      if (state.loading) {
        return;
      }

      products.forEach((product) => {
        product.quantity = 0;
      });

      setError('');
      render();
    };

    const setProductQuantity = (
      variantId,
      quantity
    ) => {
      const product = products.get(String(variantId));

      if (!product || !product.available) {
        return;
      }

      product.quantity = Math.max(
        0,
        parseNumber(quantity)
      );
    };

    const openSummary = () => {
      if (!summary || !summaryToggle) {
        return;
      }

      summary.classList.add('is-open');

      summaryToggle.setAttribute(
        'aria-expanded',
        'true'
      );
    };

    const closeSummary = () => {
      if (!summary || !summaryToggle) {
        return;
      }

      summary.classList.remove('is-open');

      summaryToggle.setAttribute(
        'aria-expanded',
        'false'
      );
    };

    const toggleSummary = () => {
      if (!summaryToggle) {
        return;
      }

      const isOpen =
        summaryToggle.getAttribute(
          'aria-expanded'
        ) === 'true';

      if (isOpen) {
        closeSummary();
      } else {
        openSummary();
      }
    };

    const buildBundleComponents = () => {
      return getSelectedProducts().map(
        (product) => ({
          variantId: product.variantId,
          quantity: product.quantity,
          price: product.price,
          title: product.title
        })
      );
    };

    const buildGiftComponents = () => {
      const totalQuantity = getTotalQuantity();

      return getUnlockedGifts(totalQuantity).map(
        (step) => ({
          variantId: step.giftVariantId,
          quantity: 1,
          title: step.giftTitle
        })
      );
    };

    const buildCartProperties = () => {
      const values = getValues();
      const productsPayload =
        buildBundleComponents();

      const giftsPayload =
        buildGiftComponents();

      return {
        _bundleKey: bundleKey,
        _bundleType: 'progressive-pack',
        _bundleComponents: JSON.stringify(
          productsPayload
        ),
        _bundleProducts: productsPayload
          .map(
            (product) =>
              `${product.variantId}:${product.quantity}`
          )
          .join(','),
        _bundleDiscount: String(
          values.discountPercentage
        ),
        _bundleQuantity: String(
          values.totalQuantity
        ),
        _bundleSubtotal: String(values.subtotal),
        _bundleTotal: String(values.total),
        _bundleGifts: JSON.stringify(
          giftsPayload
        )
      };
    };

    const createBundleId = () => {
    if (window.crypto?.randomUUID) {
        return `digi-pack-${window.crypto.randomUUID()}`;
    }

    return `digi-pack-${Date.now()}`;
    };

    const buildCartItems = () => {
    const values = getValues();
    const bundleId = createBundleId();
    const activeStep = getActiveStep(
        values.totalQuantity
    );

    const commonProperties = {
        _bundleId: bundleId,
        _bundleKey: bundleKey,
        _bundleVersion: 'progressive-pack-v1',
        _bundleDiscount: String(
        values.discountPercentage
        ),
        _bundleStep: activeStep?.id || ''
    };

    const productItems = getSelectedProducts().map(
        (product) => ({
        id: Number(product.variantId),
        quantity: product.quantity,
        properties: {
            ...commonProperties,
            _bundleRole: 'child'
        }
        })
    );

    const giftItems = getUnlockedGifts(
        values.totalQuantity
    ).map((step) => ({
        id: Number(step.giftVariantId),
        quantity: 1,
        properties: {
        ...commonProperties,
        _bundleRole: 'gift',
        _giftTitle: step.giftTitle
        }
    }));

    return [...productItems, ...giftItems];
    };

        const openCartDrawer = () => {
        const cartButton =
            document.querySelector('[data-open-cart-sidebar]') ||
            document.querySelector('[data-cart-toggle]');

        if (cartButton) {
            cartButton.click();
            return;
        }

        document.body.classList.add('open-cart-sidebar');
        };

const refreshCartDrawer = async () => {
  try {
    const response = await fetch(
      `${window.Shopify?.routes?.root || '/'}cart.js`,
      {
        headers: {
          Accept: 'application/json'
        }
      }
    );

    if (!response.ok) {
      throw new Error(
        'Não foi possível buscar o carrinho atualizado.'
      );
    }

    const cart = await response.json();

    if (typeof window.updateCart === 'function') {
      window.updateCart(cart);
    }

    document.dispatchEvent(
      new CustomEvent('digi:cart-updated', {
        detail: {
          cart,
          source: 'progressive-pack-v1'
        }
      })
    );

    document.documentElement.dispatchEvent(
      new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: {
          cart,
          source: 'digi-pack-progressivo'
        }
      })
    );

    return cart;
  } catch (error) {
    console.warn(
      '[Digi Pack Progressivo] Não foi possível atualizar o drawer:',
      error
    );

    return null;
  }
};

    const addPackToCart = async () => {
      const values = getValues();

      if (
        state.loading ||
        values.totalQuantity < minimumItems
      ) {
        return;
      }

      const items = buildCartItems();
      const hasInvalidItem = items.some((item) => {
        return (
          !Number.isSafeInteger(item.id) ||
          item.id <= 0 ||
          !Number.isSafeInteger(item.quantity) ||
          item.quantity <= 0
        );
      });

      if (!items.length || hasInvalidItem) {
        setError(
          'Um ou mais produtos do combo estão com uma variante inválida.'
        );

        console.error(
          '[Digi Pack Progressivo] Payload inválido:',
          items
        );

        return;
      }

      setLoading(true);
      setError('');
      updateSubmitButton(values.totalQuantity);

      try {
        let responseData;

        if (window.location.pathname.startsWith('/collections/')) {
          responseData = await requestCartAddWithXhr(
            CART_ADD_URL,
            items
          );
        } else {
          const response = await fetch(CART_ADD_URL, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({ items })
          });

          const responseText = await response.text();

          responseData = parseJson(
            responseText,
            {}
          );

          if (!response.ok) {
            throw new Error(
              responseData.description ||
                responseData.message ||
                'Não foi possível adicionar o combo.'
            );
          }
        }

        document.dispatchEvent(
          new CustomEvent(
            'digi-pack-progressivo:added',
            {
              detail: {
                sectionId: section.id,
                response: responseData,
                products: buildBundleComponents(),
                gifts: buildGiftComponents(),
                discountPercentage:
                  values.discountPercentage
              }
            }
          )
        );

        if (cartBehavior === 'cart') {
          window.location.href = CART_URL;
          return;
        }

        if (cartBehavior === 'checkout') {
          window.location.href =
            `${window.Shopify?.routes?.root || '/'}checkout`;
          return;
        }

        if (cartBehavior === 'drawer') {
          closeSummary();
          openCartDrawer();

          /*
            A atualização do drawer não deve manter o botão
            preso no estado de carregamento. O carrinho já foi
            confirmado pelo POST /cart/add.js neste ponto.
          */
          void refreshCartDrawer();
        }
      } catch (error) {
        const message =
          error?.name === 'TimeoutError'
            ? 'A adição demorou mais que o esperado. Verifique o carrinho e tente novamente.'
            : error.message ||
              'Não foi possível adicionar o combo. Tente novamente.';

        console.error(
          '[Digi Pack Progressivo]',
          error
        );

        setError(message);
      } finally {
        setLoading(false);
        updateSubmitButton(getTotalQuantity());
      }
    };

    const handleSectionClick = (event) => {
      const tab = event.target.closest(
        '[data-digi-pack-progressivo-tab]'
      );

if (tab && section.contains(tab)) {
  activateTab(tab.getAttribute('aria-controls'));

  return;
}


      const summaryToggleButton =
        event.target.closest(
          '[data-digi-pack-progressivo-summary-toggle]'
        );

      if (
        summaryToggleButton &&
        section.contains(summaryToggleButton)
      ) {
        toggleSummary();

        return;
      }

const summaryCloseButton = event.target.closest(
  '[data-digi-pack-progressivo-summary-close]'
);

if (
  summaryCloseButton &&
  section.contains(summaryCloseButton)
) {
  closeSummary();

  return;
}

const summaryOverlayButton = event.target.closest(
  '[data-digi-pack-progressivo-summary-overlay]'
);

if (
  summaryOverlayButton &&
  summaryOverlayButton === summaryOverlay
) {
  closeSummary();

  return;
}

      const productCard = event.target.closest(
        '[data-digi-pack-progressivo-product]'
      );

      if (
        productCard &&
        productCard.dataset.available === 'false'
      ) {
        return;
      }

        const productMinus = event.target.closest(
        '[data-digi-pack-progressivo-decrease]'
        );

      if (productMinus && productCard) {
        event.preventDefault();
        event.stopPropagation();

        changeQuantity(
          productCard.dataset.variantId,
          -1
        );

        return;
      }

        const productPlus = event.target.closest(
        '[data-digi-pack-progressivo-increase]'
        );

      if (productPlus && productCard) {
        event.preventDefault();
        event.stopPropagation();

        changeQuantity(
          productCard.dataset.variantId,
          1,
          {
            openSummary: true
          }
        );

        return;
      }

      if (
        productCard &&
        !event.target.closest('a, button, input')
      ) {
        const product = products.get(
          String(productCard.dataset.variantId)
        );

        if (product?.quantity === 0) {
          changeQuantity(
            product.variantId,
            1,
            {
              openSummary: true
            }
          );
        }

        return;
      }

      const summaryItem = event.target.closest(
        '[data-summary-variant-id]'
      );

      const summaryMinus = event.target.closest(
        '[data-summary-item-decrease]'
      );

      if (summaryMinus && summaryItem) {
        changeQuantity(
          summaryItem.dataset.summaryVariantId,
          -1
        );

        return;
      }

      const summaryPlus = event.target.closest(
        '[data-summary-item-increase]'
      );

      if (summaryPlus && summaryItem) {
        changeQuantity(
          summaryItem.dataset.summaryVariantId,
          1
        );

        return;
      }

      const clear = event.target.closest(
        '[data-digi-pack-progressivo-clear]'
      );

      if (clear && section.contains(clear)) {
        event.preventDefault();
        event.stopPropagation();

        clearSelection();

        return;
      }

      const submit = event.target.closest(
        '[data-digi-pack-progressivo-submit]'
      );

      if (submit && section.contains(submit)) {
        addPackToCart();
      }
    };

    const handleTabKeyboard = (event) => {
      const currentTab = event.target.closest(
        '[data-digi-pack-progressivo-tab]'
      );

      if (!currentTab) {
        return;
      }

      const currentIndex =
        tabs.indexOf(currentTab);

      let nextIndex = currentIndex;

      if (event.key === 'ArrowRight') {
        nextIndex =
          (currentIndex + 1) % tabs.length;
      } else if (event.key === 'ArrowLeft') {
        nextIndex =
          (currentIndex - 1 + tabs.length) %
          tabs.length;
      } else if (event.key === 'Home') {
        nextIndex = 0;
      } else if (event.key === 'End') {
        nextIndex = tabs.length - 1;
      } else {
        return;
      }

      event.preventDefault();

      const nextTab = tabs[nextIndex];

        activateTab(
        nextTab.getAttribute('aria-controls'),
        true
        );
    };

const handleSummaryKeyboard = (event) => {
  if (
    event.key === 'Escape' &&
    summary?.classList.contains('is-open')
  ) {
    closeSummary();
    summaryToggle?.focus();
  }
};

    const restoreInitialSelection = () => {
      const initialSelectionElement =
        section.querySelector(
          '[data-digi-pack-progressivo-initial-selection]'
        );

      if (!initialSelectionElement) {
        return;
      }

      const initialSelection = parseJson(
        initialSelectionElement.textContent.trim(),
        []
      );

      if (!Array.isArray(initialSelection)) {
        return;
      }

      initialSelection.forEach((item) => {
        setProductQuantity(
          item.variantId || item.id,
          item.quantity || 0
        );
      });
    };

    const initialActiveTab =
      tabs.find(
        (tab) =>
          tab.getAttribute('aria-selected') ===
            'true' ||
          tab.classList.contains('is-active')
      ) || tabs[0];

if (initialActiveTab) {
  activateTab(
    initialActiveTab.getAttribute('aria-controls')
  );
}

    restoreInitialSelection();
    render();

    section.addEventListener(
      'click',
      handleSectionClick
    );

    section.addEventListener(
      'keydown',
      handleTabKeyboard
    );

    section.addEventListener(
    'keydown',
    handleSummaryKeyboard
    );

/*
  Controla apenas a exibição da barra mobile fechada.
  Não interfere no resumo aberto nem nos seus cliques.
*/
const updateMobileSummaryTriggerVisibility = (
  isSectionVisible
) => {
  section.classList.toggle(
    'is-pack-section-visible',
    isSectionVisible
  );
};

if ('IntersectionObserver' in window) {
  const sectionVisibilityObserver =
    new IntersectionObserver(
      ([entry]) => {
        updateMobileSummaryTriggerVisibility(
          entry.isIntersecting
        );
      },
      {
        root: null,
        threshold: 0,
        rootMargin: '0px 0px -68px 0px'
      }
    );

  sectionVisibilityObserver.observe(section);
} else {
  updateMobileSummaryTriggerVisibility(true);
}
  };
  

  const initAllSections = (container = document) => {
    if (container.matches?.(SECTION_SELECTOR)) {
      initSection(container);
    }

    container
      .querySelectorAll?.(SECTION_SELECTOR)
      .forEach(initSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => initAllSections()
    );
  } else {
    initAllSections();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initAllSections(event.target);
    }
  );
})();